export default __webpack_public_path__ + "static/media/lomoIcon2-darkComplete.6e0c17b8.svg";